/**
 * Screen size widths
 */
export const ScreenSize = {
  _720: '720px',
  _920: '920px',
  _1280: '1280px',
  _1440: '1440px',
  _1920: '1920px',
};
